import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  TimeScale
} from "chart.js";
import { Line } from "react-chartjs-2";
import 'chartjs-adapter-date-fns';
import { format } from "date-fns";
import { enUS } from 'date-fns/locale';
import styles from "../../../../styles/races/national/MapResults.module.scss";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  TimeScale
);

const getOrCreateTooltip = (chart) => {
  let tooltipEl = chart.canvas.parentNode.querySelector("div");

  if (!tooltipEl) {
    tooltipEl = document.createElement("div");

    const div = document.createElement("div");
    div.style.margin = "10px";

    tooltipEl.appendChild(div);
    chart.canvas.parentNode.appendChild(tooltipEl);
  }

  tooltipEl.style.background = "#FFF";
  tooltipEl.style.opacity = 0.9;
  tooltipEl.style.boxShadow = "0px 4px 20px -5px rgba(80, 85, 139, 0.3)";
  tooltipEl.style.color = "#000";
  tooltipEl.style.border = "none";
  tooltipEl.style.borderRadius = "2px";
  tooltipEl.style.pointerEvents = "none";
  tooltipEl.style.position = "absolute";
  tooltipEl.style.transform = "translate(-110%, -50%)";
  tooltipEl.style.transition = "all .1s ease";
  tooltipEl.style.width = "200px";
  tooltipEl.zIndex = "2";

  return tooltipEl;
};

const options = {
  responsive: true,
  maintainAspectRatio: false,
  interaction: {
    mode: "index",
    axis: "y"
  },
  animation: false,
  scales: {
    x: {
      type: "time",
      time: {
        unit: "hour",
        displayFormats: {
          hour: "M/d/yy h aa"
        }
      },
      adapters: { 
        date: {
          locale: enUS
        }
      }
    },
    y: {
      grid: {
        color: "transparent"
      },
      ticks: {
        callback: (value) => {
          return new Intl.NumberFormat("en-US", {
            notation: "compact",
            maximumFractionDigits: 1,
          }).format(value);
        },
      },
    },
  },
  plugins: {
    tooltip: {
      enabled: false,
      external: (context) => {
        // Tooltip Element
        const { chart, tooltip } = context;
        const tooltipEl = getOrCreateTooltip(chart);
        // Hide if no tooltip
        if (tooltip.opacity === 0) {
          tooltipEl.style.opacity = 0;
          return;
        }

        const divRoot = tooltipEl.querySelector("div");
        const dataset = tooltip.dataPoints[0].dataset;
        const dataIndex = tooltip.dataPoints[0].dataIndex;
        
        const label = document.createElement("p");
        let transmissionPercentage = dataset.transmissionPercentage[dataIndex];
        transmissionPercentage = transmissionPercentage ? transmissionPercentage : dataset.transmissionPercentage[dataset.transmissionPercentage.length - 1];
        label.innerText = transmissionPercentage ? `Transmission Status: ${transmissionPercentage}%` : "";
        label.style.fontSize = "12px";

        const note = document.createElement("p");
        note.innerText = `As of ${format(tooltip.dataPoints[0].dataset.data[tooltip.dataPoints[0].dataIndex].x, "M/d/yy h:mm aa")}`;
        note.style.fontSize = "12px";
        note.style.marginBottom = "10px";

        // Remove old children
        while (divRoot.firstChild) {
          divRoot.firstChild.remove();
        }

        divRoot.appendChild(label);
        divRoot.appendChild(note);

        tooltip.dataPoints.forEach(dataPoint => {
          const body = document.createElement("div");
          body.style.fontSize = "12px";
          const key = document.createElement("span");
          key.innerText = dataPoint.dataset.label;
          key.style.fontWeight = "600";
          key.style.color = dataPoint.dataset.locationColor;
          const value = document.createElement("span");
          value.innerText = dataPoint.dataset.data[dataPoint.dataIndex].y;
          value.style.marginLeft = "10px";
          body.appendChild(key);
          body.appendChild(value);
          divRoot.appendChild(body);
        });
        
        const {offsetLeft: positionX, offsetTop: positionY} = chart.canvas;
        
        // Display, position, and set styles for font
        tooltipEl.style.opacity = 0.9;
        tooltipEl.style.fontFamily = "Noto Sans";
        tooltipEl.style.left = positionX + tooltip.caretX + "px";
        tooltipEl.style.top = positionY + tooltip.caretY + "px";
        tooltipEl.style.padding = tooltip.options.padding + "px " + tooltip.options.padding + "px";
      },
    },
    legend: {
      display: false
    }
  }
};

const MapTransmissionChart = ({ dataChart, place }) => {
  return (
    <>
      <h3 className={styles.title}>Transmission Status per {place}</h3>
      <Line options={options} data={dataChart} />
      <p className={styles.description} style={{ textAlign: "center", marginTop: "20px" }}>NOTE: The color of the lines correspond to the leading candidate per region/area.</p>
    </>
  );
};

export default MapTransmissionChart;
